import { Component, OnInit, Inject } from '@angular/core';
import { AppService } from '../shared/services/app.service';
import { InventoryService } from './inventory.service';
import { NotifyService } from '../shared/services/notify.service';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})
export class ViewComponent implements OnInit {

  inventory:any;
  titleBarCode:string;
  titleStatus:string;
  history:any[];

  constructor(

    //private _appService: AppService,
    private _invService: InventoryService,
    //private _notifyService: NotifyService
  ) {
    this.titleBarCode = 'Loading . . . ';
    this.titleStatus = '';
    this._invService.itemReady$.subscribe(
      (item) => {
        this.inventory = item;
        this.titleBarCode = item.barcode;
        this.titleStatus = item.status;
        this._invService.getHistory(this.inventory).subscribe(
          h => {
            this.history = [];
            for(let i = 0; i<h.history.history.length; i++) {
              this.history.push({
                showDetail: false,
                user: h.history.users[i],
                history: h.history.history[i]
              });
            }
          }
        );
      }
    );
  }

  ngOnInit() {

  }

  closeView() {
    this._invService.setViewShow(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/view.component.ts